module.exports = __webpack_public_path__ + "b47d969889fdc3f24ecf9902108e6d0f.MP3";